var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c("div", [
        _c("div", { staticClass: "columns is-gapless" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showfilter,
                  expression: "showfilter",
                },
              ],
              staticClass: "column is-narrow",
            },
            [
              _c("Repx-list-side-menu", {
                on: { filter: _vm.filterList, reset: _vm.resetList },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "tile is-parent" }, [
              _c(
                "article",
                { class: { "tile is-child": true, box: _vm.tableBoxCssOn } },
                [
                  _c(
                    "bulma-table",
                    {
                      staticClass:
                        "table is-bordered is-striped is-narrow is-fullwidth",
                      attrs: {
                        columns: _vm.columns,
                        "page-index": _vm.filter.pageIndex,
                        "page-size": _vm.filter.pageSize,
                        "total-rows": _vm.totalRows,
                        "is-loading": _vm.isTableLoading,
                        "sort-column": _vm.filter.sortColumn,
                        "sort-order": _vm.filter.sortOrder,
                      },
                      on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                    },
                    [
                      _vm._l(_vm.entities, function (RepxService, index) {
                        return _c(
                          "tr",
                          {
                            key: RepxService.quoteRepxServiceID,
                            class: { "is-selected": _vm.selectedRow === index },
                            on: {
                              click: function ($event) {
                                return _vm.highlightSelected(index, $event)
                              },
                            },
                          },
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatDateTimeLocale(
                                    RepxService.createdDate,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(RepxService.repairQuoteId)),
                            ]),
                            _c("td", [_vm._v(_vm._s(RepxService.quoteNo))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(RepxService.messageTypeDescription)
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(RepxService.remark))]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "icon",
                                  class: [
                                    RepxService.statusId == 20
                                      ? "has-text-success"
                                      : "has-text-danger",
                                  ],
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      RepxService.statusId == 20
                                        ? "mdi-check"
                                        : "mdi-close",
                                    ],
                                  }),
                                ]
                              ),
                            ]),
                            _c("td", { staticClass: "has-text-centered" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "button is-primary is-small is-inverted tooltip",
                                  attrs: { "data-tooltip": "Click to view" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleMessageClicked(
                                        RepxService
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "icon is-medium" },
                                    [
                                      _c("i", {
                                        staticClass: "mdi mdi-magnify mdi-24px",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _c("repx-message-detail", {
                    attrs: {
                      visible: _vm.isDetailActive,
                      "message-id": _vm.messageId,
                    },
                    on: { close: _vm.close },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }